<template>
  <div class="body">
    <TopNav></TopNav>
    <Main></Main>
    <Footer></Footer>
  </div>
</template>

<script>
import TopNav from "../default/TopNav"
import Footer from "../default/Footer"
import Main from "./Main"

export default {
  components: {
    TopNav,
    Footer,
    Main,
  },
}
</script>

<style></style>
